import ResetEmail from "./ResetEmail";

export default ResetEmail;
